/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';
import { GptJobSwagger } from 'src/customText/core/services/gpt/customTextGptSwagger';
import { ModelJobStates } from 'src/modules/modelTraining/types/trainingTypes';

type GptJobStoreData = OmitFunctions<Partial<Omit<GptJobStore, 'id'>>>;

export class GptJobStore {
    public id: string;

    public createdDateTime: Date;

    public elapsedTime: string;

    public expirationDateTime: Date;

    @observable public lastUpdatedDateTime: Date;

    @observable public status: ModelJobStates;

    @observable public errors: GptJobSwagger['errors'];

    constructor(id: string, data?: GptJobStoreData) {
        this.id = id;
        this.status = data?.status;
        this.errors = data?.errors;
        this.elapsedTime = data?.elapsedTime;
        this.createdDateTime = data?.createdDateTime ?? new Date();
        this.expirationDateTime = data?.expirationDateTime ?? new Date();
        this.lastUpdatedDateTime = data?.lastUpdatedDateTime ?? new Date();
    }

    @action
    public updateData(data: GptJobStoreData) {
        this.status = data.status;
        this.elapsedTime = data.elapsedTime;
        this.createdDateTime = data.createdDateTime ?? new Date();
        this.expirationDateTime = data.expirationDateTime ?? new Date();
        this.lastUpdatedDateTime = data.lastUpdatedDateTime ?? new Date();
        if (data.errors) {
            this.errors = data.errors;
        }
    }

    @action
    public setStatus(status: ModelJobStates, errors?: GptJobSwagger['errors']) {
        this.status = status;
        if (errors) {
            this.errors = errors;
        }
    }
}
